@if (pageData() && guideGroups()) {
  <div class="guide-home-container container">
    <div class="row">
      <div class="col">
        <h1
          class="guide-list-header my-6 text-3xl font-bold text-grey-1 md:text-4xl"
          id="guide-header"
        >
          {{ pageData().title.rendered }}
        </h1>

        <div class="page-content narrowed-content text-center">
          <div [innerHTML]="pageData().content.rendered | safeHtml"></div>
        </div>

        <div class="guide-taxonomy-boxes">
          @for (item of guideGroups(); track item.tag.id; let index = $index) {
            <app-guide-taxonomy-box
              [puffsLimit]="puffsLimit"
              [puffsPreloaded]="item.posts"
              [tag]="item.tag"
              [numberOfPriorityPuffs]="index === 0 ? 1 : 0"
              class="mb-8 flex flex-col justify-between"
            ></app-guide-taxonomy-box>
          }
        </div>
      </div>
    </div>
  </div>
}
